







import { Component, Mixins, Prop, Vue } from 'vue-property-decorator'
import TranslateMixin from '@/mixins/translate'

@Component
export default class NoData extends Mixins(TranslateMixin) {
  @Prop() private display!: boolean
}
